<div class="footer">
    <div class="footer-list">
        <div class="row footer-list-block">
            <div class="col footer-logo">
                <a class="navbar-brand" href="#"><img src="../../assets/images/Property box Trasnparent.png"></a>
            </div>
            <div class="col footer-list-about">

                <ul>
                    <div class="list-item-heading">About</div>
                    <li><a class="nav-link" href="javascript:void(0)"
                        (click)="scrollToSection('investors')">Company</a></li>
                    <li> <a class="nav-link" href="javascript:void(0)" (click)="scrollToSection('contactus')">Contact
                            Us</a></li>
                    <!-- <li>Terms and Service</li> -->
                    <li class="privacy-policy" (click)="privacyPolicy()"> Privacy Policy & Terms of Use</li>
                </ul>
            </div>
            <div class="col footer-list-product">
                <ul>
                    <div class="list-item-heading">Product</div>
                    <li> <a class="nav-link" href="javascript:void(0)"
                            (click)="scrollToSection('categories')">Categories</a></li>
                    <li class="pricing_list" (click)="pricingList()">Pricing</li>
                    <li> <a class="nav-link" href="javascript:void(0)"
                        (click)="scrollToSection('testimonials')">Testimonials</a></li>
                </ul>
            </div>
            <!-- <div class="col footer-list-discover">
                <ul>
                    <div class="list-item-heading">Discover</div>
                    <li>Teams</li>
                    <li>Partners</li>
                    <li>Career</li>

                </ul>
            </div> -->
            <div class="col footer-list-followus">
                <ul class="social-media-icons">
                    <li>
                        <a href="https://www.facebook.com/profile.php?id=61566727757731" target="_blank" rel="noopener noreferrer">
                            <img src="../../assets/images/facebook-f-brands-solid.svg" alt="Facebook">
                        </a>
                    </li>
                    <li>
                        <a href="https://www.instagram.com/property__box?igsh=MWVnYmc2Ym8zZWNudw==" target="_blank" rel="noopener noreferrer">
                            <img src="../../assets/images/instagram-brands-solid.svg" alt="Instagram">
                        </a>
                    </li>
                    <li>
                        <a href="https://www.linkedin.com/company/property-box-hyderabad/" target="_blank" rel="noopener noreferrer">
                            <img src="../../assets/images/linkedin-in-brands-solid.svg" alt="LinkedIn">
                        </a>
                    </li>
                </ul>
                
            </div>
        </div>
    </div>
    <div class="copy-rights">
        <div class="copy-rights-content">© 2024 - All Rights Reserved &#64;propertybox </div>
    </div>
</div>